export enum MyEditModalCloseActionTypeEnum {
    SAVE_DRAFT  = 1,
    SAVE_PROJECT,
    SAVE_AND_GENERATE_QUOTES,
    SEND_TO_BROTHER,
    SEND_TO_APPROVE,
    UNLOCK_PROJECT_LIST_ITEM
}
